export enum ESTADOEnum { CERRADO, ABIERTO, ABRIENDO, CERRANDO }
